import {
  createRouter,
  createWebHashHistory
} from 'vue-router'
// 首页
import homePage from '@/views/home/homePage.vue'
// 产业图谱
import industryMap from '@/views/industryMap/index.vue'
// 云端产业园
import industrialPark from '@/views/industrialPark/index.vue'
// 产业新闻
import newsInformationPage from '@/views/newsInformation/newsInformationPage.vue';
//详情页
import listDetails from '@/views/newsInformation/listDetails.vue';
// 产业运行
import industrialOperation from '@/views/industrialOperation/index.vue'
// 产业运行 新版
import industrialOperationNewIndex from '@/views/industrialOperation/newIndex.vue'
// 产业运行 新版 二
import industrialOperationNewIndexTwo from '@/views/industrialOperation/newIndexTwo.vue'
// 产业协同
import industrialSynergy from '@/views/industrialSynergy/index.vue'
// 关于我们
import aboutUs from '@/views/aboutUs.vue';
// 登录页
import loginPage from '@/views/login/loginPage.vue'
// 注册
import registerPage from '@/views/login/registerPage.vue'
// 忘记密码
import resetPasswordPage from '@/views/login/resetPasswordPage.vue';


// 个人中心
// 非登录页的包裹组件
const layout = () => import("@/layout");

import dashboard from "@/views/dashboard";
// 消息通知
const message = () => import("@/views/message");
// 历史管理
import historyManagement from '@/views/historyManagement.vue';
// 中标管理
import bidManagement from '@/views/bidManagement.vue';
// 认证管理
import authenticationManagement from '@/views/authenticationManagement.vue';
// 实名认证
import realNamePage from '@/views/realNamePage.vue';
// 我的项目管理
import releaseManagement from '@/views/releaseManagement.vue';
// 流转项目
import circulationProject from '@/views/circulationProject.vue';
// 新增交易项目
import addTransaction from '@/views/addTransaction.vue';
// 保证金管理
import marginManagement from '@/views/marginManagement.vue';

const routes = [{
    path: '/',
    name: 'home',
    meta: {
      title: "首页",
    },
    component: homePage
  },
  {
    path: '/industryMap',
    name: 'industryMap',
    meta: {
      title: "产业图谱",
    },
    component: industryMap
  },
  {
    path: '/industrialPark',
    name: 'industrialPark',
    meta: {
      title: "云端产业园",
    },
    component: industrialPark
  },
  {
    path: '/industrialSynergy',
    name: 'industrialSynergy',
    meta: {
      title: "产业协同",
    },
    component: industrialSynergy
  },
  {
    path: '/industrialOperation',
    name: 'industrialOperation',
    meta: {
      title: "产业运行",
    },
    component: industrialOperation
  },
  {
    path: '/industrialOperationNewIndex',
    name: 'industrialOperationNewIndex',
    meta: {
      title: "产业运行--新版",
    },
    component: industrialOperationNewIndex
  },
  {
    path: '/industrialOperationNewIndexTwo',
    name: 'industrialOperationNewIndexTwo',
    meta: {
      title: "产业运行--新版",
    },
    component: industrialOperationNewIndexTwo
  },
  {
    path: '/newsInformationPage',
    name: 'newsInformationPage',
    meta: {
      title: "产业新闻",
    },
    component: newsInformationPage
  },
  {
    path: '/listDetails',
    name: 'listDetails',
    meta: {
      title: "详情",
    },
    component: listDetails
  },
  {
    path: '/aboutUs',
    name: 'aboutUs',
    meta: {
      title: "关于我们",
    },
    component: aboutUs
  },
  {
    path: '/loginPage',
    name: 'loginPage',
    meta: {
      title: "登录页",
    },
    component: loginPage
  },
  {
    path: '/registerPage',
    name: 'registerPage',
    meta: {
      title: "注册页",
    },
    component: registerPage
  },
  {
    path: '/resetPasswordPage',
    name: 'resetPasswordPage',
    meta: {
      title: "忘记密码",
    },
    component: resetPasswordPage
  },
  {
    path: "/",
    name: "layout",
    meta: {
      title: "后台首页",
      needLogin: true,
    },
    redirect: "/dashboard",
    component: layout,
    children: [{
        path: "dashboard",
        name: "dashboard",
        meta: {
          title: "管理后台",
          needLogin: true,
        },
        component: dashboard,
      },

      {
        path: "releaseManagement",
        name: "releaseManagement",
        meta: {
          title: "我的项目",
          needLogin: true,
        },
        component: releaseManagement,
      },
      {
        path: "circulationProject",
        name: "circulationProject",
        meta: {
          title: "流转项目",
          needLogin: true,
        },
        component: circulationProject,
      },
      {
        path: "addTransaction",
        name: "addTransaction",
        meta: {
          title: "新增交易项目",
          needLogin: true,
        },
        component: addTransaction,
      },
      {
        path: "bidManagement",
        name: "bidManagement",
        meta: {
          title: "中标管理",
          needLogin: true,
        },
        component: bidManagement,
      },
      {
        path: "historyManagement",
        name: "historyManagement",
        meta: {
          title: "历史管理",
          needLogin: true,
        },
        component: historyManagement,
      },
      {
        path: "authenticationManagement",
        name: "authenticationManagement",
        meta: {
          title: "个人中心",
          needLogin: true,
        },
        component: authenticationManagement,
      },
      {
        path: "marginManagement",
        name: "marginManagement",
        meta: {
          title: "保证金管理",
          needLogin: true,
        },
        component: marginManagement,
      },
      {
        path: "realNamePage",
        name: "realNamePage",
        meta: {
          title: "实名认证",
          needLogin: true,
        },
        component: realNamePage,
      },

      {
        path: "message",
        name: "message",
        meta: {
          title: "消息通知",
          needLogin: true,
        },
        component: message,
      },
    ],
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 当一个导航触发时，全局的 before 钩子按照创建顺序调用。钩子是异步解析执行，此时导航在所有钩子 resolve 完之前一直处于等待中。
router.beforeEach((to, from, next) => {
  // 自动化修改页面标签的 title
  document.title = to.meta.title + " - 新材料（炭基导电）产业大脑";
  window.scrollTo(0, 0);
  const isLogin = localStorage.getItem("token")
  if (to.meta.needLogin) {
    if (isLogin) {
      next()
    } else {
      next({
        path: '/loginPage'
      })
    }
  } else {
    next();
  }
});

export default router